import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    description: {
      color: '#828282'
    },
    cardContent: {
      paddingTop: '0px !important',
      height: '100%',
      width: '100%'
    },
    card: {
      margin: theme.spacing(0, 2, 2, 2),
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column'
    }
  })
